// extracted by mini-css-extract-plugin
module.exports = {"root":"root__3nP3S","divider":"divider__3Y8RQ","link":"link__1RYjJ"};